const prod = {
  url: {
    BASE_URL: process.env.REACT_APP_BASE_URL || "https://api.sianext.com",
    AUTH_URL: process.env.REACT_APP_AUTH_URL || "https://api.sianext.com/auth",
  },
};

const stg = {
    url: {
      BASE_URL: process.env.REACT_APP_BASE_URL || "https://stg-api.sianext.com",
      AUTH_URL:
        process.env.REACT_APP_AUTH_URL || "https://stg-api.sianext.com/auth",
    },
};

const local = {
    url: {
      BASE_URL: process.env.REACT_APP_BASE_URL || "http://localhost:8080",
      AUTH_URL:
        process.env.REACT_APP_AUTH_URL || "http://localhost:8080/auth",
    },
};

// react-scripts forces NODE_ENV (start = development, build = production), so staging
// is picked via REACT_APP_ENV instead.
export const config =
  process.env.REACT_APP_ENV === "staging"
    ? stg
    : process.env.NODE_ENV === "production"
      ? prod
      : local;
